<template>
  <div class="rules-display"
    :class="{
      'rules-display--large': large,
      'rules-display--collapsible': collapsible
    }">
    <div class="rules-display__body"
      :class="{
        'rules-display__body--collapsed': !show
      }">
      <span class="rules-display__copy" v-html="copyBody" />

      <router-link
        class="rules-display__cta"
        :to="{
          name: termsRoute
        }">{{copyCta}}</router-link>
    </div>
  </div>
</template>

<script>
import { CONTENT_GENERAL_RULES_COPY, CONTENT_GENERAL_RULES_CTA, CONTENT_GENERAL_RULES_TITLE } from '../../design-tokens/build/dictionary';
import { ROUTE_NAMES } from '../core/config';

export default {
  name: 'rules-display',
  props: {
    collapsible: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    }
  },
  data() {
    return {
      copyTitle: CONTENT_GENERAL_RULES_TITLE,
      copyBody: CONTENT_GENERAL_RULES_COPY,
      copyCta: CONTENT_GENERAL_RULES_CTA,
      termsRoute: ROUTE_NAMES.terms,
      show: true,
    };
  },
  created() {
    // hide by default if collapsible
    this.show = !this.collapsible;
  },
  methods: {
    handleClick() {
      if (this.collapsible) {
        this.show = !this.show;
        this.$emit('click');
      }
    }
  }
};
</script>

<style lang="scss">
.rules-display {
  @include body-copy-footnote;
  position: relative;
  max-width: $size-max-width-rules-display-large;

  &--large {
    @include body-copy-x-small;
    line-height: $size-lineheight-rules-display-large-large;
    max-width: none;
  }

  &__title {
    color: $color-rules-display-title-base;
    font-weight: $font-weight-rules-display-title-base;
    cursor: pointer;
  }

  &__copy {
    color: $color-rules-display-copy-base;
    font-weight: $font-weight-rules-display-copy-base;
  }

  &__body {
  }
  &--collapsible {
    max-width: none;
    height: $size-height-rules-display-body-collapsible-small;
  }
  &__cta {
    white-space: nowrap;
    &,
    &:visited {
      color: $color-rules-display-cta-base;
      font-weight: $font-weight-rules-display-cta-base;
    }
    &:hover {
      text-decoration: underline;
    }
  }

  @include global-media('small') {
    margin-top: $size-margin-top-rules-display-small;
    font-size: $size-text-rules-display-small;
    max-width: $size-max-width-rules-display-small;
    &--collapsible {
      max-width: none;
      padding: 0 $size-padding-rules-display-collapsible-small;
    }
  }
}
</style>
